import { AudioManager } from "../../../AudioManager";
import { TurretActor } from "./TurretActor";
import { GameVars } from "../../../GameVars";
import { EnemyActor } from "../enemy-actors/EnemyActor";
import * as Anuto from "../../../../engine/src";

export class FireTurretActor extends TurretActor {

    public canonRotation: number;

    private framesDuration: number;
    private f: number;
    private laserShoot: boolean;

    constructor(scene: Phaser.Scene, position: {r: number, c: number}, turret: Anuto.Turret) {

        super(scene, Anuto.GameConstants.TURRET_FIRE, position, turret, "texture_atlas_2", true);

        this.base.setFrame("torre_7_" + turret.level + "_01");
        this.base.setOrigin(.5, .75);
        this.base.anims.play("torre_7_" + turret.level);

        this.cannon.setFrame("torre_7_" + turret.level + "_top_01");
        this.cannon.setOrigin(.5, .75);

        this.canonLength = 25;
        this.canonRotation = 0;

        let angle = (this.canonRotation * 180) / Math.PI;
        angle = angle / 45;
        this.cannon.setFrame("torre_7_" + this.anutoTurret.level + "_top_0" + (((angle + 5) % 8) + 1));

        this.laserShoot = false;
    }

    public onReady(): void {

        super.onReady();

        let fx = this.scene.add.sprite(0, 0, "texture_atlas_2");
        fx.setOrigin(.5, .75);
        this.add(fx);

        fx.anims.play("torre_7_fx");
    }

    public upgrade(): void {

        super.upgrade();

        this.base.setFrame("torre_7_" + this.anutoTurret.level + "_01");
        this.base.anims.play("torre_7_" + this.anutoTurret.level);

        let angle = (this.canonRotation * 180) / Math.PI;
        angle = angle / 45;
        this.cannon.setFrame("torre_7_" + this.anutoTurret.level + "_top_0" + (((angle + 5) % 8) + 1));
    }

    public update(time: number, delta: number): void {

        super.update(time, delta);

        if (this.laserShoot) {
            if (this.f ++ === this.framesDuration) {
                this.laserShoot = false;
            }
        }
    }

    public shootFire(enemyActors: EnemyActor[]): void {

        const dx = enemyActors[0].x - this.x;
        const dy = enemyActors[0].y - this.y;

        this.laserShoot = true;
        this.framesDuration = GameVars.timeStepFactor === 1 ? 24 : 6;
        this.f = 0;

        const rotation = Math.atan2(dy, dx) + Math.PI / 2;
        let angle = (rotation * 180) / Math.PI;
        angle = Math.round(angle / 45) * 45;
        this.canonRotation = (angle * Math.PI) / 180;
        angle = angle / 45;
        this.cannon.setFrame("torre_7_" + this.anutoTurret.level + "_top_0" + (((angle + 5) % 8) + 1));
    }
}
